import { mapState as rootMapState } from 'pinia';
import { usePageStore } from '@/store';

export default {
    emits: ['update'],
    i18next: {
        ns: 'md-footer'
    },
    props: {
        theme: {
            type: String,
            default: 'standard'
        },
        declaimerCls: {
            type: String,
            default: ''
        }
    },
    data: function() {
        return {
            mlsOrgsData: []
        };
    },
    computed: {
        ...rootMapState(usePageStore, {
            "global": store => store.page || {}
        }),
        mlsOrgs({ mlsOrgsData }) {
            let set = new Set();
            let result = mlsOrgsData
                .concat({
                    id: '',
                    logo: '',
                    declaimer: this.$t('md-footer.idxInformationIsProvided')
                })
                .filter(item => {
                    if (item.logo) {
                        if (set.has(item.logo)) {
                            return false;
                        }
                        set.add(item.logo);
                    }
                    if (item.declaimer) {
                        if (set.has(item.declaimer)) {
                            return false;
                        }
                        set.add(item.declaimer);
                    }
                    return item.isShowHome !== 0;
                });
            
            return result;
        },
        
    },
    mounted() {
        this.getMls();
    },

    methods: {
        async getMls() {
            this.mlsOrgsData = this.global.mlsOrgs || [];
            if (!this.mlsOrgsData.length) {
                return this.axiosIns
                    .post('/api-graphql', {
                        query: `{allMls{id,logo,declaimer,isShowHome}}`
                    })
                    .then(res => {
                        this.mlsOrgsData = (res.data && res.data.allMls) || [];
                        this.$emit('update', this.mlsOrgs);
                    });
            } else {
                this.mlsOrgsData = this.mlsOrgsData.filter(item => item.logo || item.declaimer)
                    .map(item => {
                        return {
                            id: item.id,
                            logo: item.logo,
                            declaimer: item.declaimer,
                            isShowHome: item.isShowHome
                        };
                    });
                this.$emit('update', this.mlsOrgs);
                return Promise.resolve(this.mlsOrgsData);
                
            }
        }
    }
};